import { Pipe, PipeTransform } from '@angular/core';

import { Document } from 'app/providers/storage-api/document.service';

@Pipe({
  name: 'titleScore',
  standalone: false,
})
export class TitleScorePipe implements PipeTransform {
  transform(item: Document, displayedColumns: string[]): number {
    return displayedColumns.includes('sentiment') ? item.analyses[0].sentimentScore : null;
  }
}
